import {BooleanValidatorDirective} from './validator';

export {BooleanDirective} from './directive';
export {BooleanPipe} from './pipe';

export const BOOLEAN_VALIDATORS = [BooleanValidatorDirective];
